import React from "react";

export default function Footer() {
  return (
    <div className="Footer">
      <p>
        This project was coded by
        <a href="https://github.com/SiiyaN" target="_blank">
          Noxolo Siya Ndlovu
        </a>{" "}
        and is
        <a
          href="https://github.com/SiiyaN/jsx-weatherApp.js-main"
          target="_blank"
        >
          {" "}
          on GitHub
        </a>{" "}
        and
        <a href="https://dancing-nasturtium-283e55.netlify.app" target="_blank">
          hosted on Netlify
        </a>
      </p>
    </div>
  );
}
